import React from 'react'
import _ from 'lodash'
import {connect} from 'react-redux'
import {config} from '../../../config/config'
import {WidgetGrid, JarvisWidget} from '../../../common';


class ProcessMapViewer extends React.Component {
    render() {
        const proUid = this.props.match.params.proUid;
        const appUid = this.props.match.params.appUid;
        const url = config.iframeServer + "designer?prj_uid=" + proUid + '&prj_readonly=true&app_uid=' + appUid + "&sid=" + localStorage.getItem('session_id');
        return (<div className="no-padding">
                        <div style={{height:"100%"}}>
                        	<iframe sandbox="allow-downloads allow-top-navigation allow-same-origin allow-scripts allow-forms allow-modals allow-popups allow-top-navigation allow-pointer-lock"
                        	        style={{width:"100%",height:"100vh",minHeight: "200px",border: "0"}}
                        	        src={url} onLoad={(t,e) => this.loadCompleted(t,e)}></iframe>
                        </div>
                    </div>);
    }


    loadCompleted(t, e) {
    }
}


export default connect((state) => (state.newInbox))(ProcessMapViewer)
